import Captcha from "./index.vue";
export default Captcha;